import React from 'react';
import RouletteLayoutMobile from "./RouletteLayoutMobile";
import {useRoulette} from "../../../store/roulette/RouletteContext";

const MobileDashboardDrawingRoulette = ({appClass}) => {
    const roulette = useRoulette();
    return <RouletteLayoutMobile {...roulette} appClass={appClass}/>;
};

export default MobileDashboardDrawingRoulette;